"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Book = function Book(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "BookTitle BookDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "BookTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "BookDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(1 1)",
    fillRule: "evenodd",
    d: "M5.442 21.815a2.755 2.755 0 0 1-2.752-2.751 2.755 2.755 0 0 1 2.752-2.752h15.754v2.5H5.823a.345.345 0 1 0 0 .69h15.373v2.313H5.442zM2.69 5.786c0-1.4 1.052-2.557 2.407-2.727v12.584a3.438 3.438 0 0 0-2.407 1.356V5.786zm10.64-2.752h4.823v7.779l-2.209-1.598a.346.346 0 0 0-.404 0l-2.21 1.598V3.034zm7.866 12.588H5.786V3.034h6.855v8.454a.344.344 0 0 0 .546.279l2.555-1.847 2.554 1.847a.345.345 0 0 0 .547-.28V3.035h2.353v12.588zm.345-13.277H5.44A3.445 3.445 0 0 0 2 5.786v13.278a3.445 3.445 0 0 0 3.44 3.441h16.1c.19 0 .344-.154.344-.345V2.69a.345.345 0 0 0-.344-.345zM8.983 5.128a.571.571 0 1 0 0 1.143.571.571 0 0 0 0-1.143"
  }));
};

Book.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Book.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Book;
exports["default"] = _default;